
import { Component, OnInit, Inject, ElementRef, NgZone, ViewChild } from '@angular/core';
import { CustomerServiceIdentity } from '../services/customer.service';
import { JobsiteService } from '../services/jobsite.service';
import { CustomerOverview, JobSiteType, CountryVM  } from '../models/customer.model';
import { NewJobsite, UpdateJobsite } from '../models/jobsite.model';
import { Tuple } from '../models/tuple.model';
import { FormControl } from '@angular/forms';
// import { } from 'googlemaps';
//import { MapsAPILoader } from '@agm/core';
import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomerSelectItem } from '../../setup-equipment/setup-equipment.model';

@Component({
    selector: 'edit-jobsite-modal',
    templateUrl: './edit-jobsite-modal.component.html',
    styleUrls: ['./edit-jobsite-modal.component.scss']
})
export class EditJobsiteModalComponent implements OnInit {
    public searchControl: FormControl;
    @ViewChild("search")
    public searchElementRef: ElementRef;
  public customerList: CustomerSelectItem[];
    public jobsiteTypeList: JobSiteType[];
    public countryList: CountryVM[];
    public selectedCustomerId: number = 0;
    public selectedJobsiteTypeId: number = 0;
    public jobsiteName: string = '';
    public fullAddress: string = '';
    public city: string = '';
    public postCode: string = '';
    public state: string = '';
    public country: string = '';
    public jobsiteId: number = 0;
    public countryId: number = 0;

    public updatingJobsite: boolean = false;
    public loadingCurrentDetails: boolean = true;

    public longtitude:number;
    public latitude:number;
    showAll:boolean=true;
    isBasicUser:number=1;
    constructor(public dialogRef: MatDialogRef<EditJobsiteModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
        private _jobsiteService: JobsiteService, private _customerService: CustomerServiceIdentity, //private mapsAPILoader: MapsAPILoader,
        private ngZone: NgZone, public snackBar: MatSnackBar, private _notifications: NotificationsService) { }

    ngOnInit() {
        if (this.data != null) {
            this.jobsiteId = this.data.jobsiteId;
        }
        this.searchControl = new FormControl();

        this._customerService.CheckUCUserType().subscribe(result => {
            this.isBasicUser = result;
            if(this.isBasicUser==1)this.showAll=true
            else this.showAll=false;
        });
        //this._customerService.getAllCustomers().subscribe(result => {
        //    this.customerList = result;
        //    this.loadCurrentDetails();
      //});
      this._customerService.getCustomerList().subscribe(result => {
        this.customerList = result;
        this.loadCurrentDetails();
      });
        this._customerService.getJobsiteTypes().subscribe(result => {
            this.jobsiteTypeList = result;
        });

        this._customerService.getAllCountries().subscribe(result => {
                      this.countryList = result;
               });
        // this.mapsAPILoader.load().then(() => {
        //     let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        //         types: ["address"]
        //     });
        //     google.maps.event.addListener(autocomplete, 'place_changed', () => {
        //         this.ngZone.run(() => {
        //             let place = autocomplete.getPlace();
        //             this.fullAddress = place.formatted_address;
        //             let addressComponents = place.address_components;
        //             addressComponents.forEach(c => {
        //                 if (c.types[0] == 'locality') {
        //                     this.city = c.long_name;
        //                 } else if (c.types[0] == 'postal_code') {
        //                     this.postCode = c.long_name;
        //                 } else if (c.types[0] == 'administrative_area_level_1') {
        //                     this.state = c.long_name;
        //                 } else if (c.types[0] == 'country') {
        //                     this.country = c.long_name;
        //                 }
        //             });
        //         });
        //     });
        // });
    }
    ShowAllFields(){
        this.showAll=true;
    }
    loadCurrentDetails() {
        this._jobsiteService.getJobsiteDetails(this.jobsiteId).subscribe(jobsite => {
            
            this.selectedCustomerId = jobsite.CustomerId;
            this.jobsiteName = jobsite.JobsiteName;
            this.fullAddress = jobsite.FullAddress;
            this.city = jobsite.City;
            this.postCode = jobsite.PostCode;
            this.state = jobsite.State;
            this.country = jobsite.Country;
            this.loadingCurrentDetails = false;
            this.selectedJobsiteTypeId = jobsite.JobsiteTypeId;
            this.countryId = jobsite.CountryId;
            this.latitude = jobsite.Latitude!=0?jobsite.Latitude:null;
            this.longtitude= jobsite.Longtitude!=0?jobsite.Longtitude:null;
        });

      
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    updateJobsite() {
        if (this.updatingJobsite)
            return;
        if (this.selectedCustomerId < 1 || this.jobsiteName.length < 1 || this.countryId < 1) {
            this.snackBar.open('Please fill in all required fields (*)', '', {
                duration: 1500,
            });
            return;
        }

        if (this.latitude < -90 || this.latitude>90) {
            this.snackBar.open('Latitude must be between -90 and 90 degrees inclusive.', '', {
                duration: 1500,
            });
            return;
        }
        if (this.longtitude < -180 || this.longtitude>180) {
            this.snackBar.open('Longitude must be between -180 and 180 degrees inclusive.', '', {
                duration: 1500,
            });
            return;
        }
        this.updatingJobsite = true;

        let newJobsite: UpdateJobsite = {
            JobsiteId: this.jobsiteId,
            JobsiteName: this.jobsiteName,
            FullAddress: this.fullAddress,
            City: this.city,
            Country: this.country,
            CreatedByUserId: 0,
            CustomerId: this.selectedCustomerId,
            PostCode: this.postCode,
            State: this.state,
            JobsiteTypeId: this.selectedJobsiteTypeId,
            CountryId: this.countryId,
            Latitude: this.latitude,
            Longtitude: this.longtitude
        };

        
        this._jobsiteService.updateJobsite(newJobsite).subscribe(result => {
            this.updatingJobsite = false;
            if (result.m_Item1 < 1) {
                this._notifications.error('Failed', 'Could not update this job site. ');
            } else {
                this._notifications.success('Job Site Updated', 'This job site has been updated successfully. ');
                this.dialogRef.close(true);
            }
        });
    }
}
